export default __webpack_public_path__ + "assets/images/f52c726358e8eb276d50272c37446e1f.jpg";